import { Permissions } from "@cnx/common";
import { ReactNode } from "react";
import { isHasRequiredRights } from "utils/rights";
import { useAuthStore } from "../../stores/authStore";

interface PrivateContentProps {
  children: ReactNode;
  rights: Permissions[];
  createdBy?: string;
}

const PrivateContent: React.FC<PrivateContentProps> = ({
  children,
  rights = [],
  createdBy,
}) => {
  const useRights = useAuthStore(state => state.useRights);
  const currentUserId = useAuthStore(state => state.currentUserId);

  if (
    !isHasRequiredRights(useRights, rights) &&
    (!createdBy || createdBy !== currentUserId)
  ) {
    return null;
  }

  return <>{children}</>;
};

export default PrivateContent;
